import Dexie from 'dexie';
import { RPCCacheRecord, RPCCacheRecordSchema } from './records/rpccache';
import { DynlsCacheRecord, DynlsCacheRecordSchema } from './records/dynlscache';
import { StateCacheRecord, StateCacheRecordSchema } from './records/statecache';
import { UserStateRecord, UserStateRecordSchema } from './records/userstate';
import { TopicCacheRecord, TopicCacheRecordSchema } from './records/topiccache';

const DBNAME = `${window.hcstatic.portal_site}_cache`;
const TOPICDB = `${window.hcstatic.portal_site}_topic_cache`;

export class CacheDB extends Dexie {
	public rpccache: Dexie.Table<RPCCacheRecord, number>;
	public dynls: Dexie.Table<DynlsCacheRecord, number>;
	public statecache: Dexie.Table<StateCacheRecord, number>;
	public userstate: Dexie.Table<UserStateRecord, number>;

	constructor(databaseName: string) {
		super(databaseName);
		this.version(1).stores({
			rpccache: RPCCacheRecordSchema,
			dynls: DynlsCacheRecordSchema,
			statecache: StateCacheRecordSchema,
			userstate: UserStateRecordSchema
		});
		// inform Typescript of what Dexie already did
		this.rpccache = this.table('rpccache');
		this.rpccache.mapToClass(RPCCacheRecord);

		this.dynls = this.table('dynls');
		this.dynls.mapToClass(DynlsCacheRecord);

		this.statecache = this.table('statecache');
		this.statecache.mapToClass(StateCacheRecord);

		this.userstate = this.table('userstate');
		this.userstate.mapToClass(UserStateRecord);
	}
}

// Instantiate it
export const db = new CacheDB(DBNAME);

export class TopicDB extends Dexie {
	public topiccache: Dexie.Table<TopicCacheRecord, number>;

	constructor(databaseName: string) {
		super(databaseName);
		this.version(1).stores({
			topiccache: TopicCacheRecordSchema
		});
		// inform Typescript of what Dexie already did
		this.topiccache = this.table('topiccache');
		this.topiccache.mapToClass(TopicCacheRecord);
	}
}

export const tdb = new TopicDB(TOPICDB);
